module.exports = __webpack_public_path__ + "8b4e697a1e6c83b69a19a6f1b4f93b1f.svg";